import { io } from "socket.io-client";
import { SOCKET_URL } from '../../../../config';

// Socket server URL based on environment
// Socket.IO expects http:// or https://, NOT ws:// or wss://
// It handles the WebSocket upgrade automatically
const API_BASE_URL = SOCKET_URL;

console.log(`🔄 Customer Portal: Connecting to ${API_BASE_URL}/portal namespace`);

let connectionStatus = 'connecting';
let connectionStatusListeners = [];
let connectionTimeout = null;

// Connect to /portal namespace for customer portal chat
const socket = io(`${API_BASE_URL}/portal`, { 
  transports: ['websocket', 'polling'], // Allow both transports for better compatibility
  timeout: 10000,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  forceNew: true // Force new connection to avoid stale connections
});

// If connection hasn't been established within 10s, mark as error to avoid perpetual 'connecting'
connectionTimeout = setTimeout(() => {
  if (connectionStatus === 'connecting') {
    console.warn('Socket connection timeout — marking status as error');
    updateConnectionStatus('error');
  }
}, 10000);

const updateConnectionStatus = (status) => {
  connectionStatus = status;
  connectionStatusListeners.forEach(listener => listener(status));
};

// Add event listeners for debugging and connection status tracking
socket.on("connect", () => {
  console.log("✅ Customer Portal: Connected to server (/portal namespace)");
  updateConnectionStatus('connected');
  // Clear any pending connection timeout once connected
  if (connectionTimeout) {
    clearTimeout(connectionTimeout);
    connectionTimeout = null;
  }
});

socket.on("disconnect", (reason) => {
  console.log("🔌 Customer Portal: Disconnected:", reason);
  updateConnectionStatus('disconnected');
});

socket.on("connect_error", (error) => {
  console.error("❌ Customer Portal: Connection error:", error);
  updateConnectionStatus('error');
});

socket.on("disconnect", (reason) => {
  console.log("🔌 Customer Portal: Disconnected:", reason);
  updateConnectionStatus('disconnected');
});

// Add debugging for message events
socket.on("receive-message", (message) => {
  console.log("📨 Customer Portal: Received message:", message);
});

socket.on("channel-messages", (messages) => {
  console.log("📚 Customer Portal: Received channel messages:", messages?.length || 0);
});

// Export connection status utilities
export const getConnectionStatus = () => {
  try {
    if (socket && socket.connected) return 'connected';
  } catch (e) {
    console.warn('Error checking socket status:', e);
  }
  return connectionStatus;
};

export const onConnectionStatusChange = (listener) => {
  connectionStatusListeners.push(listener);
  // Immediately notify the new listener of current authoritative status
  try {
    listener(getConnectionStatus());
  } catch (e) {
    console.error('Error in connection status listener', e);
  }
  // Return unsubscribe function
  return () => {
    connectionStatusListeners = connectionStatusListeners.filter(l => l !== listener);
  };
};

export default socket;
